import libAxios from 'axios';

import { axiosDefaultTimeout } from './constants';
import { snakeToCamel } from './common';

function getTransformResponse(blacklist) {
  return function(data) {
    let jsonResp;

    try {
      jsonResp = JSON.parse(data);
    } catch (e) {
      return {};
    }

    return snakeToCamel(jsonResp, blacklist);
  };
}

const axiosGlobalConfig =
  process.env.NODE_ENV === 'development'
    ? {}
    : {
        timeout: axiosDefaultTimeout * 1000,
        baseURL: process.env.REACT_APP_API_URL,
      };

axiosGlobalConfig.transformResponse = [getTransformResponse()];

const axios = libAxios.create(axiosGlobalConfig);

axios.interceptors.response.use(
  (response) => {
    if (response.data.errCode) {
      return Promise.reject(response);
    }

    if (response.data && response.data.result) {
      response.data = response.data.result;
    } else {
      response.data = {};
    }

    return response;
  },
  (error) => Promise.reject(error.response)
);

export { axios, getTransformResponse };

class Resources {
  constructor(classConfig) {
    this.classConfig = classConfig || {};
  }

  _fetch = (method, uri, data, config = {}) =>
    axios({
      method,
      url: uri,
      [method === 'get' ? 'params' : 'data']: data,
      ...this.classConfig,
      ...config,
    });

  verify({ shopId, shopOrderId, amount, currency, sign }) {
    return this._fetch('post', '/check_shop', {
      shop_id: shopId,
      shop_order_id: shopOrderId,
      amount,
      currency,
      sign,
    });
  }

  getPayMethods() {
    return this._fetch('get', '/paymethods');
  }

  getPayWaysForPayMethod(id) {
    return this._fetch('get', `/paymethods/${id}/payways`);
  }

  getPayWay(id) {
    return this._fetch('get', `/payways/${id}`, undefined, {
      // don't transform add_ons to camelCase
      transformResponse: [getTransformResponse(['add_ons'])],
    });
  }

  createInvoice(payWayId, addOns) {
    return this._fetch(
      'post',
      '/invoices',
      { pw_alias: payWayId, ...addOns },
      {
        // don't transform add_ons to camelCase
        transformResponse: [getTransformResponse(['data'])],
      }
    );
  }

  getInvoiceStatus(id) {
    return this._fetch('get', `/invoices/${id}/status`);
  }

  getWarning(lng, id) {
    return this._fetch('get', `/${lng}/warnings/${id}`);
  }

  getDescription(lng, id) {
    return this._fetch('get', `/${lng}/descriptions/${id}`);
  }

  getManual(lng, id) {
    return this._fetch('get', `/${lng}/manuals/${id}`);
  }

  uploadFingerprint(fingerprint) {
    return this._fetch(
      'post',
      '/fingerprint',
      { ...fingerprint },
      {
        // don't transform add_ons to camelCase
        transformResponse: [getTransformResponse(['data'])],
      }
    );
  }
}

export default function resources(config = {}) {
  return new Resources(config);
}
